import {
  CardContent,
  Card,
  Grid,
  Typography,
  Link,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import ResponsiveDrawer from "../components/ClippedResponsiveDrawer";
import { getPublicImagePath } from "../App";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    image: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    primary: {
      marginTop: theme.spacing(2),
      alignItems: 'center',
      justifyContent: 'center',
      top: `50%`,
      left: `50%`,
    },
  })
);
export default function CriticalFailure(settings:{title:string,children:JSX.Element|JSX.Element[]}) {
  const classes = useStyles();
  return (
    <ResponsiveDrawer title={settings.title}>
    <Grid container spacing={1} className={classes.primary}>
      <Grid item>
        <Card className={classes.primary}>
          <CardContent>
            <Alert severity="error">
              <AlertTitle>{settings.title}</AlertTitle>   
              <div>{settings.children}</div>
              <Typography paragraph>If this error continues, open a support ticket with <Link href='https://cona.service-now.com/navpage.do'>CONA ServiceNOW</Link>. </Typography>
            </Alert>
            <br/>
            <img className={classes.image} src={getPublicImagePath(`/VendBroken.png`)} alt={"Critical Error"}></img>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
    </ResponsiveDrawer>
  );
}